<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <ValidationObserver ref="form" v-slot="{ passes }">
            <v-form @submit.prevent="passes(filtergrid)" class="mb-5">
              <v-card>
                <v-expansion-panels v-model="panel" multiple focusable>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{
                      $t("language.filter")
                      }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container grid-list-xl>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.departmentid"
                                :items="DepartmentList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.department')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.branchid"
                                :items="BranchList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.branch')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.personid"
                                :items="PersonList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.person')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 class="pad0"></v-flex>
                            <v-flex xs12 sm12 md3>
                              <ValidationProvider
                                :name="$t('language.fromdate')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <eng-nep-date-picker
                                  :error-messages="errors[0]"
                                  v-model="grid.filter.fromdate"
                                  :label="$t('language.fromdate')"
                                ></eng-nep-date-picker>
                              </ValidationProvider>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <ValidationProvider
                                :name="$t('language.todate')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <eng-nep-date-picker
                                  :error-messages="errors[0]"
                                  v-model="grid.filter.todate"
                                  :label="$t('language.todate')"
                                ></eng-nep-date-picker>
                              </ValidationProvider>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          dense
                          color="general"
                          class="mr-2"
                          light
                          type="submit"
                        >{{ $t("language.filter") }}</v-btn>
                        <v-btn dense class="mr-2" light @click="resetFilter">
                          {{
                          $t("language.clear")
                          }}
                        </v-btn>
                        <v-btn dense color="general" light @click="newItem">
                          {{
                          $t("language.new")
                          }}
                        </v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-form>
          </ValidationObserver>
          <v-dialog v-model="dialog" max-width="600px">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-title>
                    {{
                    $t("language.lateinearlyoutapplicationposting")
                    }}
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.person')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.personid"
                              :items="PersonList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.person')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.lateinearlyout')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.type"
                              :items="LateInEarlyOutList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.lateinearlyout')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.date')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.date"
                              :label="$t('language.date')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.approver')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.approvedbyid"
                              :items="ApproverList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.approver')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.approveddate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.approveddate"
                              :label="$t('language.approveddate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 class="pad0"></v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            v-if="$store.getters.settings.enablerecommender"
                            v-model="showrecommender"
                            :label="$t('language.recommender')"
                          ></v-switch>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-if="
                            $store.getters.settings.enablerecommender &&
                              showrecommender
                          "
                        >
                          <ValidationProvider
                            :name="$t('language.recommender')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.recommendedbyid"
                              :items="RecommenderList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.recommender')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md4
                          v-if="
                            $store.getters.settings.enablerecommender &&
                              showrecommender
                          "
                        >
                          <ValidationProvider
                            :name="$t('language.recommendeddate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.recommendeddate"
                              :label="$t('language.recommendeddate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 class="pad0"></v-flex>
                        <v-flex xs12 sm12 md12>
                          <ValidationProvider
                            :name="$t('language.remarks')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              v-model="vModel.remarks"
                              :label="$t('language.remarks')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      dense
                      color="grey darken-1"
                      text
                      @click="closedialog"
                    >{{ $t("language.cancel") }}</v-btn>
                    <v-btn
                      v-if="!isEdit"
                      color="green darken-1"
                      @click="passes(saveandreset)"
                      text
                      type="button"
                    >{{ $t("language.saveandreset") }}</v-btn>
                    <v-btn dense color="blue darken-1" text type="submit">
                      {{
                      $t("language.save")
                      }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>

          <v-data-table
            :headers="grid.headers"
            :items="grid.body"
            :search="grid.search"
            :options.sync="grid.options"
            :server-items-length="grid.total"
            :loading="grid.loading"
            :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
            class="elevation-2"
          >
            <template v-slot:header.person>
              <span>{{ $t("language.person") }}</span>
            </template>
            <template v-slot:header.date>
              <span>{{ $t("language.date") }}</span>
            </template>
            <template v-slot:header.type>
              <span>{{ $t("language.type") }}</span>
            </template>
            <template v-slot:header.remarks>
              <span>{{ $t("language.remarks") }}</span>
            </template>
            <template v-slot:item.date="{ item }">
              {{getDefaultDate(item.date)}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">edit</v-icon>
              <v-icon small @click="deleteItem(item.id)">delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Base from "../../../shared/Base.vue";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import commonservice from "../../../shared/common.service";
export default {
  name: "lateinearlyoutapplicationpostingview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      panel: [1],
      DepartmentList: [],
      BranchList: [],
      PersonList: [],
      LateInEarlyOutList: commonservice.LateInEarlyOutList,
      ApproverList: [],
      RecommenderList: [],
      showrecommender: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get("client/posting/lateinearlyoutapplications/init/list")
      .then((response) => {
        next((p) => {
          p.DepartmentList = response.data.departments;
          p.BranchList = response.data.branches;
          p.PersonList = response.data.persons;
          (p.ApproverList = response.data.approvers),
            (p.RecommenderList = response.data.recommenders);
        });
      });
  },
  created() {
    this.resetFilter();
    this.grid.headers = [
      { value: "person" },
      { value: "date" },
      { value: "type" },
      { value: "remarks" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      date: moment().format("YYYY-MM-DD"),
      personid: null,
      type: null,
      remarks: null,
      approvedbyid: null,
      approveddate: moment().format("YYYY-MM-DD"),
      recommendedbyid: null,
      recommendeddate: null,
    };
    this.url = "client/posting/lateinearlyoutapplications";
    this.panel = [...Array(1).keys()].map((k, i) => i);
  },
  methods: {
    resetFilter() {
      this.grid.filter = {
        fromdate: moment().format("YYYY-MM-DD"),
        todate: moment().format("YYYY-MM-DD"),
        branchid: null,
        departmentid: null,
        personid: null,
      };
      //this.grid.loadoninit = false;
      this.grid.body = [];
      this.grid.total = 0;
    },
    onEditDataRecieved() {
      if (this.vModel.recommendedbyid != null) this.showrecommender = true;
      else this.showrecommender = false;
    },
  },
};
</script>
